import { Row, Card } from 'antd'

import ROIStyle from '../../styles/ROICarWars.module.css'

const ROICarWars = () => {
  return (
    <div className={`${ROIStyle["ROI-car-wars-screen"]}`}>
      <Row justify="center">
        <Card className={`${ROIStyle["ROI-car-wars-card"]}`}>
          <Row justify="center">
            <figure>
              <img alt="roicarlogo" src="https://assets.cure.com/img/main-site/roi_cars_logo.png" />
            </figure>
          </Row>
          <article>
            <hr />
            <span>MONDAY, NOVEMBER 2, 2020 &nbsp;|&nbsp;ROI-NJ.COM</span>
            <hr />
            <p>
              <h2>Insurance & Ethics</h2>
            </p>
            <h1 className={`${ROIStyle["ROI-car-wars-title"]}`}>CAR WARS</h1>
            <p className={`${ROIStyle["ROI-car-wars-author-name"]}`}>
              BY BRETT JOHNSON
              <span className={`${ROIStyle["email-below-author-name"]}`}>bjohnson@roi-nj.com</span>
            </p>
            <hr />
            <h5>
              Sponsors of N.J., federal bills and their Champion, CUREs Eric Poe - target common factors in auto
              insurance rates that they say are discriminatory
            </h5>
            <br />
            <figure className={`${ROIStyle["left"]}`}>
              <img
                alt="person"
                className={`${ROIStyle["ROI-car-wars-left-img"]}`}
                src="https://assets.cure.com/img/main-site/eric_roi_car_wars.png"
              />
              <figcaption>Eric S. Poe, Esq., CPA</figcaption>
            </figure>
            <p>
              After honing the art of articulating what he alleges are discriminatory practices among automotive
              insurers, Eric Poe was once again first in line to stand before New Jersey policymakers last week, giving
              soaring testimony- one that he had to begin with an apology.
            </p>
            <p>
              He&apos;s passionate, he said, but that&apos;s often mistaken for anger or arrogance. He&apos;s
              frustrated. It&apos;s something he feels shouldn&apos;t even be an argument.
            </p>
            <p>
              Simply put, Poe feels something needs to be done about the in-built biases in auto insurance underwriting.
              And, he might add, why hasn&apos;t something been done already?
            </p>
            <p>
              The industry he himself is in - he is the chief operating officer of the not-for-profit CURE Auto
              Insurance -uses four things to determine auto insurance rates, none of which has anything to do with
              driving, all of which disproportionately hurt people of color and lower income:
            </p>
            <p>
              Simply put, Poe feels something needs to be done about the in-built biases in auto insurance underwriting.
              And, he might add, why hasn&apos;t something been done already?
            </p>
            <p>
              <b>■</b> Educational attainment;
            </p>
            <p>
              <b>■</b> Homeownership;
            </p>
            <p>
              <b>■</b> Occupation;
            </p>
            <p>
              <b>■</b> Credit scores.
            </p>
            <p>
              The bill he was providing testimony for (S111) before the state Senate Commerce Committee - which
              successfully earned a 3-1 vote and was released to the full Senate - would force auto insurers to use only
              the most obvious factor in determining insurance rates: driving records.
            </p>
            <p>
              The N.J. legislation, sponsored by Sens. Nia Gill (D-Montclair), Teresa Ruiz (D-Newark), Nilsa Cruz-Perez
              (D-Camden) and Nellie Pou (D-Paterson), mirrors what&apos;s being pushed on the federal level at the same
              time by two New Jersey policymakers, with separate bills in both the U.S.Senate and House of
              Representatives.
            </p>
            <p>
              House of Representatives. Whether the result will be different than the many other times Poe testified in
              front of the New Jersey Senate, Congress and even other state legislatures is not something anyone
              involved feels overly certain about.
            </p>
            <p>
              The only certainty - or, at least, the certainty of some anonymous figure who delivered an unmarked
              envelope to Poe&apos;s company - is that Poe would be the right person to make the case for it.
            </p>
            <p>
              Fifteen years ago, he was dumbfounded to be the chosen recipient of a pile of internal insurance company
              memos describing in detail the practice of using non-driving factors to determine insurance rates.
            </p>
            <p>Apparently, the sender knew something about his personality.</p>
            <p>
              Poe has never given up on whistling blowing on his own sector, even if his years of outspokenness have
              earned him the animus of the entire industry around him. There are a few companies besides CURE Auto
              Insurance that don&apos;t take advantage of the way businesses are allowed to categorize customer risk
              with non-driving factors.
            </p>
            <p>But there hasn&apos;t been much movement to change things.</p>
            <p>
              The last time Poe&apos;s crusade had as much promise behind it was in 2007, after a Star­ Ledger article
              revealed how the insurance industry operated and two bills were sponsored in reaction to it (but later
              lost traction). Poe said he was immediately pulled into a meeting with an industry group.
            </p>
            <p>
              &quot;They asked why I was doing this; and I said, &quot;Well, I think it&apos;s wrong;&quot; he said.
              &quot;You know what they said? I&apos;ll never forget it. &quot;Eric; they said, &quot;you&apos;re talking
              about ethics, and we&apos;re talking about business&quot; Poe said he&apos;ll be first to admit it: He was
              never too good at telling the two apart.
            </p>
            <p>
              Although Poe has experienced many ups and downs in the mission he&apos;s taken on himself in the years
              since having that mystery package fall in his lap, he&apos;s just as certain that good business and good
              ethical business practices aren&apos;t mutually exclusive.
            </p>
            <figure className={`${ROIStyle["right"]}`}>
              <img
                alt="person2"
                className={`${ROIStyle["ROI-car-wars-left-img"]}`}
                src="https://assets.cure.com/img/main-site/roi_cars_john_hannon.png"
              />
              <figcaption>John Harmon, CEO, African American Chamber of Commerce of New Jersey</figcaption>
            </figure>
            <p>
              There are other New Jersey business leaders who tend to agree with him. <b>John Hannon</b>, CEO of the
              African American Chamber of Commerce of New Jersey, has been a close ally throughout the years.
            </p>
            <p>
              He, like Poe, believes that the industry&apos;s socio-economic classifications have unfortunately been
              used as a proxy for race, even if a person&apos;s race cannot be asked for directly by companies.
            </p>
            <p>
              &quot;When you look at Black and brown people in New Jersey, you have the highest poverty, highest
              unemployment, lowest net worth;&quot; Harmon said &quot;But you need a car to get to work, school or to
              just be a caretaker.... Why in the world would you be penalized for your education, credit score or
              occupation?&quot; Harmon notes his priorities are squarely business-first: He always wants companies to be
              as profitable as possible, he said.
            </p>
            <p>
              At the same time, he also wants there to be a fair and amicable relationship between consumers and
              businesses in the Garden State. And, at the very least, he&apos;s asking for some transparency.
            </p>
            <p>
              &quot;Because some people are quite surprised to find out this even exists in New Jersey:&quot; Harmon
              said. &quot;Residents are being hoodwinked and bamboozled because they just don&apos;t know. Along with
              the already high cost of living in the state, people don&apos;t realize they&apos;re being fleeced just to
              drive in the state:&quot;
            </p>
            <p>
              Cynical as it may come across, Poe said it&apos;s only due to a lack of awareness around this issue that
              insurance company marketing teams were able to &quot;get equity from something like the Black Lives Matter
              movement&quot; in the wake ofGeorge Floyd&apos;s death earlier tllis year.
            </p>
            <p>
              The hope of Poe and other advocates for this reform is that the current moment of racial justice reckoning
              is the right time to hold these companies to account.
            </p>
            <p>
              &quot;This isn&apos;t imagery; this is reality,&quot; Poe said. &quot;People are being charged 70 to 80%
              more when they&apos;re drivers with no tickets or accidents, simply because they don&apos;t have a
              high-paying job. How does that continue to be OK ... if we&apos;re going to say something like Aunt Jemima
              isn&apos;t?&quot;
            </p>
            <p>
              Overtly race-based insurance plans were once a standard practice at many of the country&apos;s insurance
              companies. Through a combination of civil rights advocacy and the Civil Rights Act of 1964, insurers had
              to remove any and all questions about race from their application process.
            </p>
            <p>
              Even so, major life insurance companies had to swiftly settle a number of class action lawsuits over the
              past two decades, as allegations piled up that race-based plans were being continued in different forms. A
              case involving Mutual Savings Life Insurance Co. was one such example. In the 2002 court filing, the
              plaintiff alleged that African Americans could historically purchase only &quot;colored&quot; policies,
              which had higher premiums than the company&apos;s &quot;white&quot; plans.
            </p>
            <p>
              Although these minority-designated policies were discontinued in the 60s, the plaintiff in the case argued
              that the race­ based distinctions did not end. The company was accused of either keeping minorities on
              expired policies or simply moving them to the &quot;substandard&quot; category of the company&apos;s three
              sets of premiums.
            </p>
            <p>
              Other life insurance companies - offering a product that&apos;s not mandatory, unlike auto insurance,
              which is required under New Jersey law- have been the subject of state department examinations for
              practices that have led to higher premiums for African Americans.
            </p>
            <p>
              Today, insurers across the board say they&apos;re dedicated to maintaining a fair system for customers.{' '}
              <b>David Snyder</b>, who represents members of the <b>American Property Casualty Insurance Association</b>
              , the country&apos;s main insurance trade association, said questions about occupation or education just
              provide a more complete picture of a driver&apos;s potential for filing a claim or the cost of claims.
            </p>
            <p>
              &quot;Auto insurers have collected data for decades and have found that the factors of education,
              occupation and credit-based insurance scores are all accurate variables for predicting the likelihood and
              cost of insurance claims;&quot; he said. &quot;There have also been numerous studies of these factors by
              state and federal regulators and others tl1at have confirmed that they are accurate indicators of risk of
              loss and have shown that they are not proxies for race or income:&quot;
            </p>
            <p>
              New Jersey didn&apos;t always allow for this criterium to be used by insurance carriers. Some say the
              change to allow them was made in 2003, when state leaders wanted to entice GEICO to return to the Garden
              State after an almost 30-year absence.
            </p>
            <p>
              Prior to that, there were certain membership-based insurers, such as <b>NJM Insurance Group</b>, the
              Garden State&apos;s second­ largest writer of personal auto insurance, that required applicants to belong
              to certain occupations or trade organizations. But no insurance carriers were using both occupation and
              education simultaneously on a large scale in the local market.
            </p>
            <p>
              &quot;New Jersey had been a consumer­ protecting environment for car insurance;&quot; Poe said. &quot;And
              what&apos;s happened since bringing <b>GEICO </b>
              and <b>Progressive</b> into the state? The uninsured population in the state has gone up:&quot; According
              to Poe, as well as available data from the Insurance Research Council, the uninsured motorist rate rose
              from 8% to 15% between 2007 and 2015 in New Jersey.
            </p>
            <p>
              &quot;We just about doubled the people who couldn&apos;t afford car insurance as these factors
              proliferated;&quot; Poe said. &quot;We .vent up 86% in that time. If you would say that about any other
              insurance, or industry, you&apos;d say it&apos;s an epidemic that needs to be addressed:&quot;
            </p>
            <hr />
          </article>
        </Card>
      </Row>
    </div>
  )
}

ROICarWars.propTypes = {}

export default ROICarWars
